import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/bank.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/consult.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ecommerce.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/estate.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/he.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/health.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/hg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/hl.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/hp.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/hy.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/it.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/manufacture.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/public.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/cards.webp");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/industry.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Home/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Home/PopupClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Home/Service.js");
